import styles from "./tasklist.module.css";
import Helmet from "react-helmet";
import { LinearProgress, Typography } from "@mui/material";
import { Home } from "react-feather";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../../components/Loader";
import { TableLoaderSmall } from "../../../components/LoaderC";
import Footer from "../../../components/Footer";
import TaskFilter from "./components/TaskFilter";
import TaskCard from "./components/TaskCard";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);

const TaskList = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [contentLoading, setContentLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [allData, setAllData] = useState([]);
  const [completionBar, setCompletionBar] = useState(0);
  const [filterData, setFilterData] = useState({ searchKey: "" });
  const [activeAccordion, setActiveAccordion] = useState(null);

  const todayDate = dayjs().format("MMMM Do, YYYY");

  useEffect(() => {
    const getTaskList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_CASE_API_URL + "v1/today-task-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch(() => {
        setContentLoading(false);
      });
    };

    getTaskList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (allData.length > 0) {
      let filteredDataTemp = allData;

      if (filterData.searchKey !== "") {
        let inputVal = filterData.searchKey;
        inputVal = inputVal.toLowerCase();
        filteredDataTemp = filteredDataTemp.filter((item) => {
          return (item.title.toLowerCase().includes(inputVal) || item.property_name.toLowerCase().includes(inputVal));
        });
      }

      setTaskList(filteredDataTemp);
    }
  }, [allData, filterData]);

  useEffect(() => {
    const getGlobalCompletion = () => {
      const total = allData.reduce((sum, task) => sum + task.today_check_list.length, 0);
      const completed = allData.reduce((sum, task) => sum + task.today_check_list.filter((i) => i.is_checked === 1).length, 0);
      return total === 0 ? 0 : Math.round((completed / total) * 100);
    };

    const globalPercentage = getGlobalCompletion();
    setCompletionBar(globalPercentage);
  }, [allData]);

  return (<>
    {loading && <Loader />}

    <Helmet title="Task Lists" />

    <div className={`${styles.pageTitleWrap}`}>
      <Typography display="inline" className={`${styles.pageTitle}`}>Task Lists <span>{todayDate}</span></Typography>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Requests</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>Tasks</li>
        </ol>
      </nav>
    </div>

    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          {contentLoading && (<div className="Loader TableLoader">
            <TableLoaderSmall />
          </div>)}

          {!contentLoading && (<div className="control-pane">
            <div className={`${styles.Row}`}>
              <TaskFilter setFilterData={setFilterData} />

              {allData.length > 0 && (<div className={`${styles.ProgressBar} ProgressBar`}>
                <LinearProgress variant="determinate" value={completionBar} />
                <p className={`${styles.ProgressTitle}`}>Todays Completed Tasks <span>{completionBar}%</span></p>
              </div>)}

              <div className={`${styles.NotesRow}`}>
                {taskList.map((item, index) => {
                  return (<TaskCard key={index} item={item} index={index} setAllData={setAllData.bind(this)} activeAccordion={activeAccordion} setActiveAccordion={setActiveAccordion} setLoading={setLoading.bind(this)} />);
                })}

                {!contentLoading && taskList.length === 0 && (<div className={`${styles.NoDataMain}`}>
                  <div className={`${styles.NoDataIMG}`}>
                    <img src="/static/img/checklist.png" alt="No Data" />
                  </div>
                  <p className={`${styles.NoDataText}`}>All clear!</p>
                  <p className={`${styles.NoDataTextSub}`}>You don’t have any tasks yet.</p>
                </div>)}
              </div>
            </div>
          </div>)}
        </div>
      </div>
    </div>

    <Footer />
  </>);
};

export default withAuthenticationRequired(TaskList, {
  onRedirecting: () => <Loader />,
});